module.exports = __webpack_public_path__ + "img/private_policy.4bfeab1d.jpg";